import { useCallback, useEffect, useState } from "react";
import {getMonthFromDate } from "../../../extensions/date";
import {
  getHaryanaRemcData,
  getHaryanaGnaTgnaData,
  getHaryanaIsgsData,
} from "../../../Rest_api/RestApi";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../components/recharts/functions";
import { ExchangeColors } from "../../Dashboard/Exchange3/FormatData";
import {
  ReMixChart,
} from "../../../components/recharts/ReMixCharts";
import { H_CHART_TYPES } from "../const";
import FilterMenu from "../../../components/FilterMenu";
import Loading from "../../../components/Loading";
import { renderHourTick } from "../../../components/recharts/components";
import LegendSummaryTable, {
  ChartTable,
  downloadChartTableCSV,
  downloadSummaryCSV,
  LegendSummaryTableProps,
} from "../../../components/table/SummaryTable";
import NewFilterContainer from "../../../components/NewFilterContainer ";
import MainPageContainer from "../../../components/MainPageContainer";
import SecondaryHeader from "../../Rajasthan/Demand/SecondaryHeader";
import Tooltip from "../../../components/tooltip";
import { useSelector } from "react-redux";
import { formatDateForAPI } from "../const";
import { AddDatesWithFileName } from "../../../helpers/helper";

// const colors = [
//   "orange",
//   "red",
//   "blue",
//   "Maroon",
//   "brown",
//   "green",
//   "darkgreen",
//   "purple",
//   "black",
//   "cyan",
//   "magenta",
//   "gold",
//   "teal",
//   "navy",
// ];

const SHORT_TERM_LEGENDS = [
  {
    key: "OA_GNA Buy",
    label: "OA GNA Buy",
    color: ExchangeColors[8],
    stackId: "generation",
  },
  {
    key: "OA_TGNA Buy",
    label: "OA TGNA Buy",
    color: ExchangeColors[7],
    stackId: "generation",
  },
  {
    key: "Collective Buy",
    label: "Collective",
    color: ExchangeColors[4],
    stackId: "generation",
  },
  {
    key: "OA_GNA Sell",
    label: "OA GNA Sell",
    color: "black",
    stackId: "sell",
  },
  {
    key: "OA_TGNA Sell",
    label: "OA TGNA Sell",
    color: "purple",
    stackId: "sell",
  },
  {
    key: "Collective Sell",
    label: "Collective Sell",
    color: "magenta",
    stackId: "sell",
  },
];
// const Y_AXIS = ["Price", "Short Term Procurement %"];

const LEGENDS = [
  {
    key: "ISGS",
    label: "Interstate Generation",
    color: ExchangeColors[3],
    stackId: "generation",
  },

  {
    key: "Intra Generation",
    label: "Intrastate Generation",
    color: ExchangeColors[0],
    stackId: "generation",
  },
  {
    key: "IntraState RE Generation",
    label: "IntraState RE Generation",
    color: "#00FF00",
    stackId: "generation",
  },
  {
    key: "InterState RE Generation",
    label: "OA RE Buy",
    color: "green",
    stackId: "generation",
  },
];

const DISCOM_LEGENDS = [
  // Ajmer Discom, Jaipur Discom, Jodhpur Discom
  {
    key: "Ajmer Discom",
    label: "Ajmer Discom",
    stackId: "discom",

    color: ExchangeColors[1],
  },
  {
    key: "Jaipur Discom",
    label: "Jaipur Discom",
    stackId: "discom",

    color: ExchangeColors[2],
  },
  {
    key: "Jodhpur Discom",
    label: "Jodhpur Discom",
    stackId: "discom",

    color: ExchangeColors[3],
  },
];

const TOTAL_DISCOM_LEGENDS = [
  {
    key: "Total Discom",
    label: "Discom Load",
    color: ExchangeColors[1],
    stackId: "discom",
  },
];

const KEYS: {
  name: string;
  firstKey: string;
  secondKey: string | undefined;
}[] = [
  { name: "Time Slot", firstKey: "slot", secondKey: "date" },
  { name: "Date", firstKey: "date", secondKey: undefined },
  { name: "Month", firstKey: "month", secondKey: undefined },
];

const UNITS = ["MW", "MWh"];
const CONSUMPTION = [
  {
    label: "Total",
    value: TOTAL_DISCOM_LEGENDS,
  },
  {
    label: "By Discom",
    value: DISCOM_LEGENDS,
  },
];

export default function HaryanaOverview() {

    const dataTab = useSelector((state: any) => state.viewMode.activeView);
    const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
    const DefaultDates = useSelector(
      (state: any) => state.defaultDatesSetter.defaultDates
    );
  const [data, setData] = useState<any[]>([]);  
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedKey, setSelectedKey] = useState(KEYS[0]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [selectedConsumption, setSelectedConsumption] = useState(
    CONSUMPTION[0]
  );
  const [selectedUnit, setSelectedUnit] = useState(UNITS[0]);
  const [selectedEntity, setSelectedEntity] = useState<string[]>([]);
  const [selectedChartType, setSelectedChartType] = useState(H_CHART_TYPES[1]);
  let getActivity = useCallback(()=>{
    return [
      { label: "Consumption", value: selectedConsumption.value },
      { label: "Generation", value: LEGENDS },
      {
        label: "Buy",
        value: SHORT_TERM_LEGENDS.filter((item) =>
          item.stackId.includes("generation")
        ),
      },
      {
        label: "Sell",
        value: SHORT_TERM_LEGENDS.filter((item) =>
          item.stackId.includes("sell")
        ),
      },
    ];
  },[selectedConsumption.value]);
  
  const [selectedActivity, setSelectedActivity] = useState(getActivity());


  let _handleFetchData = useCallback(async ()=>{
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;
    const startDateStr = formatDateForAPI(dates.startDate);
    const endDateStr = formatDateForAPI(dates.endDate);
    // Initiate all API calls concurrently
    const [isgsData, remcData, gnaTgnaData] = await Promise.all([
      getHaryanaIsgsData({ startDate: startDateStr, endDate: endDateStr }),
      getHaryanaRemcData({ startDate: startDateStr, endDate: endDateStr }),
      getHaryanaGnaTgnaData({ startDate: startDateStr, endDate: endDateStr }),
    ]);

    // Process the data concurrently
    const processedIsgsData = isgsData
      .map((item) => ({
        ...item,
        entity: "ISGS Station",
        type: "ISGS",
       
      }))
      .filter((item) => item.value_mw > 0);

    const processedGnaTgnaData = gnaTgnaData
      .map((item) => {
        const isBuy = item.value_mw > 0;
        return {
          ...item,
          type: `GNA/TGNA ${isBuy ? "Buy" : "Sell"}`,
          entity: "GNA/TGNA",
          toEntity: "GNA/TGNA",
        };
      })
      .filter((item) => item.value_mw > 0);

    const processedRemcData = remcData
      .map((item) => {
        return {
          ...item,
          type: `REMC`,
          entity: "REMC",
        };
      })
      .filter((item) => item.value_mw > 0);

    // Combine all processed data
    const newData = [
      ...processedIsgsData,
      ...processedRemcData,
      ...processedGnaTgnaData,
    ];
    // unique entities are unique entity and toEntity
    console.log(newData);
    setLoading(false);
    setData(newData);

  },[DefaultDates, activeTab]);

useEffect(() => {
    _handleFetchData();
  }, [_handleFetchData]);
  
  useEffect(() => {
    setSelectedActivity(getActivity());
  }, [getActivity]);

  useEffect(() => {
    const processedDiscomData = data.map((item) => ({
      ...item,
     
      value_mw: item.value_mw || 0,
            value_mwh: (item.value_mw / 4) || 0,
      month: getMonthFromDate(item.date),
    }));

    let filteredData = processedDiscomData;
    if (selectedEntity.length > 0) {
      filteredData = filteredData.filter(
        (item) =>
          selectedEntity.includes(item.entity!) ||
          selectedEntity.includes(item.toEntity!)
      );
    }

  
    const params: ChartDataParams = {
      keys: selectedKey.secondKey
        ? [selectedKey.firstKey, selectedKey.secondKey]
        : [selectedKey.firstKey],
      groupBy: ["type"],
      volumeKey: "",
      aggregationKeys: ["value_mw","value_mwh"],
      averageKeys:[
        "value_mw"
      ],
      averageDuplicationKeys:["date","slot"],
      priceKey: "",
      data: filteredData,
    };

    const chartData = FormatChartData(params);
    let finalData = chartData.data.map((item) => {
      const total = selectedConsumption.value.reduce((acc, column) => {
        return acc + item[column.key + "_value_" + selectedUnit.toLowerCase()];
      }, 0);
      const shortTerm = SHORT_TERM_LEGENDS.filter(
        (e) => e.stackId == "generation"
      )
        .map((legend) => legend.key + "_value_" + selectedUnit.toLowerCase())
        .reduce((acc, column) => {
          return acc + item[column];
        }, 0);
      const percent = total > 0 ? (shortTerm / total) * 100 : 0;
      const dataItems = data.filter((dataItem) => {
        return (
          item.time_slot === dataItem.slot &&
          item.date === dataItem.date &&
          (dataItem.type == "Collective Buy" ||
            dataItem.type == "Collective Sell")
        );
      });

      const iex_dam = dataItems.find(
        (dataItem: any) =>
          dataItem.exchange__name === "IEX" && dataItem.product__name === "DAM"
      ) as any;
      const iex_rtm = dataItems.find(
        (dataItem: any) =>
          dataItem.exchange__name === "IEX" && dataItem.product__name === "RTM"
      ) as any;
      const iex_gdam = dataItems.find(
        (dataItem: any) =>
          dataItem.exchange__name === "IEX" && dataItem.product__name === "GDAM"
      ) as any;
      const pxil_rtm = dataItems.find(
        (dataItem: any) =>
          dataItem.exchange__name === "PXIL" && dataItem.product__name === "RTM"
      ) as any;

      return {
        ...item,
        shortTerm: percent,
        IEX_DAM_value_mw: iex_dam ? iex_dam.wt_mcp_rs_kwh : 0,
        IEX_RTM_value_mw: iex_rtm ? iex_rtm.wt_mcp_rs_kwh : 0,
        IEX_GDAM_value_mw: iex_gdam ? iex_gdam.wt_mcp_rs_kwh : 0,
        PXIL_RTM_value_mw: pxil_rtm ? pxil_rtm.wt_mcp_rs_kwh : 0,
      };
    });

    setChartData(finalData);
    setChartKeys(chartData.keys);
    setTableData(finalData || []);
  }, [data, selectedKey, selectedConsumption, selectedEntity, selectedUnit]);

  const handleUnitChange = (index: number) => {
    setSelectedUnit(UNITS[index]);
  };
  const handleKeyChange = (index: number) => {
    setSelectedKey(KEYS[index]);
  };

  const tablePar: LegendSummaryTableProps = {
    legends: getActiveLegends(),
    data: chartData,
    tableData:tableData,
    unit: selectedUnit.toLowerCase() as "mw" | "mwh" | "mus" | undefined,
    extraKeys: selectedKey.secondKey
      ? [selectedKey.firstKey, selectedKey.secondKey]
      : [selectedKey.firstKey],
    extraLabels: selectedKey.secondKey
      ? [selectedKey.firstKey, selectedKey.secondKey]
      : [selectedKey.firstKey],
      filename: AddDatesWithFileName({
            fileName: "Overview",
            dates: DefaultDates[activeTab].defaultRangeDate,
          }),
  };

  return (
    <div className="page-container">
      {loading && <Loading />}
      <div className="gas-page-container">
        <NewFilterContainer>
          <div className="side-filters-container text-nowrap">
            <FilterMenu
              title="Interval"
              items={KEYS.map((item) => item.name)}
              selectedItems={[selectedKey.name]}
              onSelect={(item, index) => {
                handleKeyChange(index);
              }}
            />
            <FilterMenu
              title="Unit"
              items={UNITS}
              selectedItems={[selectedUnit]}
              onSelect={(item, index) => {
                handleUnitChange(index);
              }}
            />
            {/* <FilterMenu
              title="Load"
              items={CONSUMPTION.map((item) => item.label)}
              selectedItems={[selectedConsumption.label]}
              onSelect={(item, index) => {
                setSelectedConsumption(CONSUMPTION[index]);
              }}
            /> */}
            {/* <FilterMenu
              title="Activity"
              items={getActivity().map((item) => item.label)}
              selectedItems={selectedActivity.map((item) => item.label)}
              setSelectedItems={(v: string[]) => {
                setSelectedActivity(
                  getActivity().filter((item) => v.includes(item.label)) as any
                );
              }}
            /> */}
            <FilterMenu
              title="Chart Type"
              items={H_CHART_TYPES.map((item) => item.label)}
              selectedItems={[selectedChartType.label]}
              onSelect={(item, index) => {
                setSelectedChartType(H_CHART_TYPES[index]);
              }}
            />
        </div>
        </NewFilterContainer>
        <MainPageContainer>
          <SecondaryHeader/>
            <div className="gas-chart-container">
            <div className="gas-heading">
            <h2 className="chartHeading w-60">Overview</h2>
            <div className="flex gap-x-6 w-full justify-end">
              <button
                onClick={() => {
                  dataTab.label === "Chart" && downloadChartTableCSV(tablePar);
                  //

                  dataTab.label === "Summary" && downloadSummaryCSV(tablePar);

                  dataTab.label === "Table" && downloadChartTableCSV(tablePar);
                }}
                className="downloadButton"
              >
                Download Data
              </button>

              {/* <div className="min-w-80">
                <SearchBox
                  options={uniqueEntities.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  isMany={true}
                  placeholder="Search Entities"
                  selectedOptions={selectedEntity.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  onChange={(item: any) => {
                    setSelectedEntity(item.map((item: any) => item.value));
                  }}
                />
              </div> */}
            </div>
          </div>

          {dataTab.label === "Chart" && (
            <ReMixChart
              data={chartData}
              xDataKey={selectedKey.firstKey}
              xTick={
                selectedKey.secondKey !== undefined
                  ? (value: any, index: any) => {
                      return renderHourTick(value, 10);
                    }
                  : undefined
              }
              secondXDataKey={selectedKey.secondKey}
              unit={selectedUnit}
              isTimeSlot={selectedKey.firstKey === "slot"}
              onlyTitle={true}
              secondYAxisLabel="Short Term Procurement %"
              barCategoryGap={12}
              yAxisLabel={selectedUnit}
              showBrush={getShowBrush(chartData)}
              brushIndex={getBrushIndex()}
              legends={getActiveLegends()}
            />
          )}
          {dataTab.label === "Summary" && <LegendSummaryTable {...tablePar} />}
          {dataTab.label === "Table" && <ChartTable {...tablePar} />}
        </div>
        <div className="gna-footer-container">
                <div className="grid grid-cols-3 justify-between gap-5 ">
                  <Tooltip
                    note={<div>HPGC, Eltrix, WBES</div>}
                    text="1. Short Term Procurement % = (Collective + TGNA)/Total Discom Load 
                    2. Intrastate Generation = Eltrix schedule
                    3. Intrastate RE Generation =  NREB Grid Curves

    4. Interstate Generation = ISGS WBES
    5. MW = Represents the average (MW) when the selected time interval is Date or Month.
    "
                  >
                    <p className="gna-footer-text">Source</p>
                  </Tooltip>
                  <p className="gna-footer-text col-span-1 text-center">
                    Powered by <strong>GNA Energy</strong>
                  </p>
                  <strong className="gna-footer-text col-span-1 text-end">
                    Beta Version
                  </strong>
                </div>
              </div>
        </MainPageContainer>
      </div>
    </div>
  );

  function getActiveLegends() {
    // const activityLegends =
    //   selectedActivity.length === 0
    //     ? selectedConsumption.value.concat(LEGENDS).concat(SHORT_TERM_LEGENDS)
    //     : selectedActivity.map((item) => item.value).flat();

    // return activityLegends
    //   .map((legend) => {
    //     return {
    //       dataKey: legend.key + "_value_" + selectedUnit.toLowerCase(),
    //       name: legend.label + " (" + selectedUnit + ")",
    //       stroke: legend.color,
    //       stackId: selectedChartType.stackId ? legend.stackId : undefined,
    //       type: selectedChartType.value,
    //     };
    //   })
    //   .concat([
    //     {
    //       dataKey: "shortTerm",
    //       name: "Short Term Procurement %",
    //       yAxisId: "right",
    //       stroke: lightenColor(ExchangeColors[2], 20),
    //       stackId: "generation",
    //       type: ChartType.Line,
    //     } as any,
    //   ]) as LegendKey[];
    return chartKeys.map((item, index) => {
      return {
        dataKey: item + "_value_" + selectedUnit.toLowerCase(),
        name: item,
        stackId: selectedChartType.stackId,
        type: selectedChartType.value,

        stroke: ExchangeColors[index],
      } as any;
    });
  }

  function getShowBrush(chartData: any[]): boolean {
    if (selectedKey.firstKey === "slot") {
      return chartData.length > 96 * 1;
    } else {
      return chartData.length > 7;
    }
  }

  function getBrushIndex(): { startIndex: number; endIndex: number } {
    if (selectedKey.firstKey === "slot") {
      return { startIndex: 0, endIndex: 96 * 1 };
    } else {
      return { startIndex: 0, endIndex: 7 };
    }
  }
}
